import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=3e1e848d&scoped=true&"
import script from "./DropZone.vue?vue&type=script&lang=ts&"
export * from "./DropZone.vue?vue&type=script&lang=ts&"
import style0 from "./DropZone.vue?vue&type=style&index=0&id=3e1e848d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1e848d",
  null
  
)

export default component.exports